<template>
  <b-navbar fixed toggleable="lg" :variant="getLayoutNavbarBg()" class="layout-navbar align-items-lg-center container-p-x py-3 bg-white text-dark">
    <b-navbar-brand to="/" >
      <img src="../assets/logos/dvr.png" class="logo-logo">
      <img src="../assets/logos/rtg.png" class="logo-logo">
    </b-navbar-brand>
    <!-- Sidenav toggle -->
    <b-navbar-nav class="align-items-lg-center mr-auto mr-lg-4" v-if="sidenavToggle">
      <a class="nav-item nav-link px-0 ml-2 ml-lg-0" href="javascript:void(0)" @click="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>
    <b-collapse is-nav id="app-layout-navbar">
      <b-navbar-nav class="align-items-lg-center mx-auto">
        <b-nav-item class="px-3 IBM-font" to="/" :exact="true">
          Home
        </b-nav-item>
        <b-nav-item class="px-3 IBM-font" to="/quem-somos" :exact="true">
          Quem Somos
        </b-nav-item>
        <b-nav-item class="px-3 IBM-font" to="/portfolio" :exact="true">
          Portfólio
        </b-nav-item>
        <b-nav-item class="px-3 IBM-font" to="/servicos" :exact="true">
          Serviços
        </b-nav-item>
        <b-nav-item class="px-3 IBM-font" to="/trabalhe-conosco" :exact="true">
          Trabalhe Conosco
        </b-nav-item>
        <b-nav-item class="px-3 IBM-font" to="/fale-conosco" :exact="true">
          Fale Conosco
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'app-layout-navbar',
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },
    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans&display=swap');

  .IBM-font {
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 700;
  }

  .navbar-light .navbar-nav .nav-link {
    color: #282f35 !important;
  }

  .navbar-light .navbar-nav .nav-link:hover {
    color: #989898 !important;
  }

  .logo-logo {
    width: 80px;
  }
  @media (min-width: 320px) and (max-width: 425px) {
    .logo-logo {
      width: 55px;
    }
  }
</style>
